import {
  faApple,
  faGoogle,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MDBCol, MDBContainer, MDBRow } from 'mdbreact';
import React, { useState } from 'react';
import {
  Dataset,
  Chart,
  Textarea,
  Card,
  FileSelector,
  Button,
  Input,
  CheckboxToggle,
} from 'react-rainbow-components';
import { useHistory } from 'react-router-dom';
import ShowNotification from '../shared/Notification';

export interface propsToEdit {
  location: {
    state: {
      Id: number;
      titre: string;
      artiste: string;
      photo: string;
      apple_music: string;
      youtube: string;
      priorite: number;
      votes: number;
      categorie: {
        Categorie_1: string;
        Categorie_2: string;
        Categorie_3: string;
      };
      categorie_1: string;
      categorie_2: string;
      categorie_3: string;
      annee: number;
      jazler_id: number;
      nouveaute: number;
      current_played: { data: []; labels: string[]; annee: string[] };
      played: { labels: []; data: number[] };
    };
  };
}

const EditMusic: React.FC<propsToEdit> = (props: propsToEdit) => {
  const [Titre, setTitre] = useState<string>(props.location.state.titre);
  const [ErrorTitre, setErrorTitre] = useState<string>('');

  const [Artiste, setArtiste] = useState<string>(props.location.state.artiste);
  const [ErrorArtiste, setErrorArtiste] = useState<string>('');

  const [Apple_Music, SetApple_Music] = useState<string>(
    props.location.state.apple_music
  );
  const [Youtube, SetYoutube] = useState<string>(props.location.state.youtube);

  const [Nouveaute, SetNouveaute] = useState<boolean>(
    props.location.state.nouveaute === 1 ? true : false
  );

  const [Jazler_id, SetJazler_id] = useState<number>(
    props.location.state.jazler_id
  );

  const [Annee, SetAnnee] = useState<number>(props.location.state.annee);

  const [Categories, SetCategories] = useState<{
    Categorie_1: string;
    Categorie_2: string;
    Categorie_3: string;
  }>(props.location.state.categorie);

  const [Priorite, SetPriorite] = useState<number>(
    props.location.state.priorite
  );

  const [Votes, SetVotes] = useState<number>(props.location.state.votes);

  const [Played, setPlayed] = useState<{ labels: []; data: number[] }>(
    props.location.state.played
  );

  const [Current_played, setCurrent_played] = useState<{
    data: [];
    labels: string[];
    annee: string[];
  }>(props.location.state.current_played);

  const [Image, setImage] = useState<{ image: string; file: string | Blob }>({
    image: props.location.state.photo,
    file: '',
  });
  const [ErrorImage, setErrorImage] = useState<string>('');

  const [loading, setLoading] = useState<boolean>(false);

  const [UploadError, setUploadError] = useState<boolean>(false);

  const colors = ['#2d2180', '#d43f3a', '#ffc107', '#061c3f'];
  const history = useHistory();
  console.log(history.location.state);

  const update = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('file', Image.file === '' ? '' : Image.file);
    formData.append(
      'data',
      JSON.stringify({
        Id: props.location.state.Id,
        titre: Titre.replace(/'/g, "\\'"),
        artiste: Artiste,
        apple_music: Apple_Music,
        youtube: Youtube,
        nouveaute: Nouveaute === true ? 1 : 0,
        annee: Annee,
        jazler_id: Jazler_id,
        priorite: Priorite,
        categorie: Categories,
        votes: Votes,
      })
    );
    const requestOptions = {
      method: 'PUT',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
      body: formData,
    };
    await fetch(
      'https://admin.radioemotion.be/api/music/update',
      requestOptions as RequestInit
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.response === true) {
          console.log(response.response);
          history.push({
            pathname: '/music/list',
            state: { passed: true, message: `Le titre a été mise à jour ` },
          });
          setLoading(false);
        } else {
          setUploadError(true);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setUploadError(true);
      });
  };

  const copyToClipboard = (content: string) => {
    const el = document.createElement('textarea');
    el.value = content;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    // window.open(`https://tools.applemediaservices.com/apple-music`, "_blank");
  };

  return (
    <>
      {UploadError ? (
        <>
          <ShowNotification
            icon="times"
            iconClassName="color-red"
            bodyClassName="background-color-red text-white"
            autohide={5000}
            title=""
            message="Une erreur s'est produite"
            text="maintenant"
          />
        </>
      ) : null}
      <MDBContainer className="pt-5">
        <MDBRow>
          <MDBCol md={'12'} xs={'12'} sm={'12'} className="mb-5">
            <Textarea
              label="Titre"
              rows={2}
              placeholder="Titre"
              grow={true}
              value={Titre}
              onChange={(e) => {
                setTitre(e.target.value);
                {
                  e.target.value === ''
                    ? setErrorTitre('Le titre est obligatoire')
                    : setErrorTitre('');
                }
              }}
              error={ErrorTitre}
            />
          </MDBCol>
          <MDBCol md={'12'} xs={'12'} sm={'12'} className="mb-5">
            <Textarea
              label="Artiste"
              rows={2}
              placeholder="Artiste"
              grow={true}
              value={Artiste}
              onChange={(e) => {
                setArtiste(e.target.value);
                {
                  e.target.value === ''
                    ? setErrorArtiste('Le titre est obligatoire')
                    : setErrorArtiste('');
                }
              }}
              error={ErrorArtiste}
            />
          </MDBCol>
        </MDBRow>
        <MDBRow className="mb-5">
          <MDBCol md="2">
            <MDBCol className="p-0">
              <Card>
                <img
                  src={Image.image}
                  className="w-100"
                  alt="image de la pochette"
                />
              </Card>
              <FileSelector
                className="mt-2"
                error={ErrorImage}
                bottomHelpText={'jpeg, png, webp ou jpg svp'}
                accept="png"
                onChange={(value) => {
                  setErrorImage('');
                  if (value.length === 1 && value[0].type) {
                    if (
                      value[0].type === 'image/jpeg' ||
                      value[0].type === 'image/png' ||
                      value[0].type === 'image/jpg' ||
                      value[0].type === 'image/webp'
                    ) {
                      setImage({
                        image: URL.createObjectURL(value[0]),
                        file: value[0],
                      });
                      console.log(value[0]);
                      console.log(URL.createObjectURL(value[0]));
                      console.log(Image);
                    } else {
                      setErrorImage('Format non supporté');
                    }
                  } else {
                    setImage({
                      ...Image,
                      file: '',
                      image: props.location.state.photo,
                    });
                  }
                }}
              />
            </MDBCol>
          </MDBCol>
          <MDBCol md="10" className="">
            <MDBCol md="8" className="offset-2">
              <a
                href={`https://toolbox.marketingtools.apple.com/en-us/apple-music/be`}
                target="_blanc"
              >
                <Button
                  variant="neutral"
                  className="mr-3"
                  onClick={() => {
                    copyToClipboard(`${Artiste} ${Titre}`);
                  }}
                >
                  <FontAwesomeIcon icon={faApple} className="" />
                  <p className="pl-2">Recherche Apple Music</p>
                </Button>
              </a>
              <a
                href={`https://www.google.be/search?q=${Artiste}+${Titre}&tbm=isch`}
                target="_blanc"
              >
                <Button variant="neutral" className="mr-3">
                  <FontAwesomeIcon icon={faGoogle} className="pr-2" />{' '}
                  <p className="pl-2"> Recherche Google</p>
                </Button>
              </a>
              <a
                href={`https://www.youtube.com/results?search_query=${Artiste.replace(
                  '&',
                  ''
                )}+${Titre.replace('&', '')}`}
                target="_blanc"
              >
                <Button variant="neutral">
                  <FontAwesomeIcon icon={faYoutube} className="pr-2" />{' '}
                  <p className="pl-2"> Recherche Youtube</p>
                </Button>
              </a>
            </MDBCol>
            <MDBCol md="12" className="pl-0 mt-3">
              <Input
                value={Apple_Music}
                label={'Apple Music'}
                className="mb-3"
                onClick={(e) => SetApple_Music('')}
                iconPosition="right"
                onChange={(event) => {
                  SetApple_Music(event.target.value);
                }}
                icon={<FontAwesomeIcon icon={faTimesCircle} />}
              />
              <Input
                value={Youtube}
                label={'Youtube'}
                iconPosition="right"
                onClick={(e) => SetYoutube('')}
                icon={<FontAwesomeIcon icon={faTimesCircle} />}
                onChange={(event) => {
                  SetYoutube(event.target.value);
                }}
              />
            </MDBCol>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol
            md="2"
            className="offset-2 grid justify-content-center align-item-center"
          >
            <label className="">Nouveauté</label>
            <CheckboxToggle
              className="mb-0 mt-2"
              value={Nouveaute}
              onChange={(event: React.ChangeEvent<HTMLElement>) => {
                SetNouveaute(!Nouveaute);
              }}
            />
          </MDBCol>
          <MDBCol md="2">
            <Input
              label="Année"
              placeholder="Année"
              value={Annee}
              onChange={(e) => {
                setArtiste(e.target.value);
                {
                  e.target.value === ''
                    ? setErrorArtiste('Le titre est obligatoire')
                    : setErrorArtiste('');
                }
              }}
              error={ErrorArtiste}
              isCentered={true}
            />
          </MDBCol>
          <MDBCol md="2">
            <Input
              label="JAZLER ID"
              placeholder="JAZLER ID"
              value={Jazler_id}
              onChange={(e) => {
                SetJazler_id(parseInt(e.target.value));
              }}
              error={ErrorArtiste}
              isCentered={true}
            />
          </MDBCol>
          <MDBCol md="2" className="">
            <Input
              label="Priorité"
              placeholder="Priorité"
              value={Priorite}
              onChange={(e) => {
                SetPriorite(parseInt(e.target.value));
              }}
              error={ErrorArtiste}
              isCentered={true}
            />
          </MDBCol>
        </MDBRow>
        <MDBRow className="mb-5 mt-5">
          <MDBCol md="2" className="offset-2">
            <Input
              label="Catégorie 1"
              placeholder="Catégorie 1"
              value={Categories.Categorie_1}
              onChange={(e) => {
                SetCategories({ ...Categories, Categorie_1: e.target.value });
              }}
              error={ErrorArtiste}
              isCentered={true}
            />
          </MDBCol>
          <MDBCol md="2">
            <Input
              label="Catégorie 2"
              placeholder="Catégorie 2"
              value={Categories.Categorie_2}
              onChange={(e) => {
                SetCategories({ ...Categories, Categorie_2: e.target.value });
              }}
              error={ErrorArtiste}
              isCentered={true}
            />
          </MDBCol>
          <MDBCol md="2">
            <Input
              label="Catégorie 3"
              placeholder="Catégorie 3"
              value={Categories.Categorie_3}
              onChange={(e) => {
                SetCategories({ ...Categories, Categorie_3: e.target.value });
              }}
              error={ErrorArtiste}
              isCentered={true}
            />
          </MDBCol>
          <MDBCol
            md="2"
            className="grid justify-content-center align-item-center"
          >
            <Input
              label="Votes"
              placeholder="Votes"
              value={Votes}
              onChange={(e) => {
                SetVotes(parseInt(e.target.value));
              }}
              error={ErrorArtiste}
              isCentered={true}
            />
          </MDBCol>
        </MDBRow>
        <MDBRow className="mb-5 mt-4">
          <MDBCol md="6" className="">
            <Chart
              labels={Current_played.labels}
              type="line"
              legendPosition={'top'}
              showLegend={true}
            >
              {Current_played.data.map((data: any, index: number) => (
                <Dataset
                  key={index}
                  title={Current_played.annee[index]}
                  values={data}
                  borderColor={colors[index]}
                  backgroundColor={colors[index]}
                />
              ))}
            </Chart>
          </MDBCol>
          <MDBCol md="6" className="">
            <Chart
              labels={Played.labels}
              type="bar"
              legendPosition={'bottom'}
              showLegend={true}
            >
              <Dataset
                title={'nombre'}
                values={Played.data}
                borderColor={'black'}
                backgroundColor={'#2d2180'}
              />
            </Chart>
          </MDBCol>
        </MDBRow>
        <MDBRow end>
          <Button
            isLoading={loading}
            label="Mettre à jour"
            onClick={() => update()}
            variant="brand"
            className="mt-2 mb-4 font-weight-bold"
          />
        </MDBRow>
      </MDBContainer>
    </>
  );
};

export default EditMusic;
